import type { DatePeriod, IsoDate } from '../data/types';

export function previousDatePeriod(period: DatePeriod): DatePeriod {
  const from = new Date(`${period.from}T00:00:00Z`);
  const to = new Date(`${period.to}T00:00:00Z`);
  const duration = Math.round((to.getTime() - from.getTime()) / 86_400_000) + 1;
  const previousTo = new Date(from);
  previousTo.setUTCDate(previousTo.getUTCDate() - 1);
  const previousFrom = new Date(previousTo);
  previousFrom.setUTCDate(previousFrom.getUTCDate() - duration + 1);
  return {
    from: previousFrom.toISOString().slice(0, 10) as IsoDate,
    to: previousTo.toISOString().slice(0, 10) as IsoDate,
  };
}
